/* External dependencies */
import { Div, Text } from 'atomize';
import { Trans, useI18next } from 'gatsby-plugin-react-i18next';
import React, { useEffect, useRef, useState } from 'react';

/* Local dependencies */
import Dropdown from '@shared/ui/button/dropdown/dropdown';
import ArrowLanguageIcon from '../../../../svg/ArrowLanguageIcon';
import SvgEarthIcon from '../../../../svg/SvgEarthIcon';
import '../style.scss';

export default function DropdownIntl() {
  const { originalPath } = useI18next();

  const [menuDropdown, setMenuDropdown] = useState(false);
  const ref = useRef(null);

  function showMenuDropdown() {
    if (menuDropdown) setMenuDropdown(false);

    setMenuDropdown(!menuDropdown);
  }

  function checkIfClickedOutside(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      setMenuDropdown(false);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, []);

  const dropdownList = [
    {
      originalPath,
      lang: 'ru',
      name: (
        <Div d="flex" align="center" m={{ b: '12px' }}>
          <Text tag="span" p={{ r: '4px' }}>
            Русский
          </Text>
        </Div>
      ),
    },
    {
      originalPath,
      lang: `ky`,
      name: (
        <Div d="flex" align="center" m={{ b: '12px' }}>
          <Text tag="span" p={{ r: '4px' }}>
            Кыргызча
          </Text>
        </Div>
      ),
    },
    {
      originalPath,
      lang: `en`,
      name: (
        <Div d="flex" align="end" m={{ b: '12px' }}>
          <Text tag="span" p={{ r: '4px' }}>
            English
          </Text>
        </Div>
      ),
    },
    {
      originalPath,
      lang: `uz`,
      name: (
        <Div d="flex" align="end" m={{ b: '12px' }}>
          <Text tag="span" p={{ r: '4px' }}>
            Ўзбекча
          </Text>
        </Div>
      ),
    },
  ];

  return (
    <Div
      cursor="pointer"
      pos="relative"
      d="flex"
      flexDir="column"
      align="center"
    >
      <Div d="flex">
        <button className="intl-button" onClick={showMenuDropdown}>
          <Div
            d="flex"
            m={{ r: '10px' }}
            justify="space-between"
            align="center"
          >
            <Text tag="span" d={{ xs: 'none', sm: 'inline' }}>
              <SvgEarthIcon width={24} height={24} />
            </Text>
            <Text
              textSize="smallSize2"
              p={{ x: '10px' }}
              textColor="bg_color_banner"
              d={{ xs: 'none', sm: 'inline' }}
            >
              <Trans>selectLanguage</Trans>
            </Text>
            <Text
              textSize="smallSize2"
              p={{ x: '10px' }}
              textColor="bg_color_banner"
              d={{ xs: 'inline', sm: 'none' }}
            >
              <Trans>selectLanguageMobile</Trans>
            </Text>
            <ArrowLanguageIcon />
          </Div>
        </button>
      </Div>
      <Div onClick={showMenuDropdown} ref={ref}>
        <Dropdown
          items={dropdownList}
          activeClass={menuDropdown ? 'active' : null}
        />
      </Div>
    </Div>
  );
}
